import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { PropsWithChildren, useEffect, useState } from 'react';
import { SectionHeader } from '../../components/SectionHeader';
import { MenuItems } from '../../view-models/workoutEdit.viewModel';
import { useAutoAnimate } from '@formkit/auto-animate/react';

export const TemplateWrapper = (
  p: PropsWithChildren<{
    name: string;
    menuItems: MenuItems;
    header: { icon: IconProp; title: string };
    isCircuit?: boolean;
    readonly?: boolean;
    expand: boolean;
  }>,
) => {
  const [ref] = useAutoAnimate({ duration: 200 });

  const [open, setOpen] = useState(true);
  useEffect(() => {
    if (p.expand) setOpen(true);
  }, [p.expand]);

  const toggle = (ev: React.MouseEvent<HTMLDivElement>) => {
    ev.preventDefault();
    ev.stopPropagation();
    setOpen((prev) => !prev);
  };
  const title = !p.name || p.name === '' ? p.header.title : p.name;
  return (
    <div ref={ref}>
      <div onClick={toggle} className="cursor-pointer">
        <SectionHeader
          title={title}
          menuItems={p.menuItems}
          icon={p.header?.icon}
          isCircuit={p.isCircuit}
          readonly={p.readonly}
        />
      </div>
      {open ? p.children : null}
    </div>
  );
};
